import React from 'react';
class PlatformName extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            platformType: props.platformType,
            iconSize: props.iconSize?props.iconSize:"tinyIcon",   //iconSize的值取  大：bigIcon  中：middleIcon 小：smallIcon  最小:tinyIcon
            isHidePatformName:props.isHidePatformName?props.isHidePatformName:false
        };
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        this.setState({
            platformType: props.platformType,
        })
    }
    render() {

        let {platformType,isHidePatformName,iconSize}=this.state;

        let platformName=platformType=="Taobao"?"淘宝平台":
            platformType=="KuaiShou"?"快手平台":
            platformType=="TouTiao"?"抖音":
            platformType=="Pinduoduo"?"拼多多":
            platformType=="WxVideo"?"微信视频号":
            platformType=="XiaoHongShu"?"小红书":
            platformType=="KuaiTuanTuan"?"快团团":
            platformType=="YouZan"?"有赞":
            platformType=="WeiMeng"?"微盟":"";

        let classNamePlatformName= isHidePatformName?"":"hasPlatformName";
        let elems =
            <span className={"platformName-wrap "+classNamePlatformName}>
                    <i className={"newPlatformIcon " + platformType +" "+iconSize}></i>
                    {
                        isHidePatformName?null:<span>{platformName}</span>
                    } 
            </span>
        return (
            elems
        );
    }
}

export default PlatformName;



// WEBPACK FOOTER //
// ./src/components/platformName/index.jsx